import React from 'react'

const AddEditEmployeeTransfer = () => {
  return (
    <div>
      
    </div>
  )
}

export default AddEditEmployeeTransfer
